export enum MRCustomEventTypes {
  FUNCTIONS_DISCOUNT_CODE_APPLY = 'functionsDiscountCodeApply',
}

export interface MRCustomEvent {
  requestType: string;
}

export interface FunctionsDiscountCodeApplyEvent extends MRCustomEvent {
  mrCart: any;
}
